import { RUN_ENV } from '~/modules/constans';
import i18n from '~/translations';

export const RUN_ENV_LABEL = {
  [RUN_ENV.LOCAL]: i18n.t('runMetadata.meta.env.local.label'),
  [RUN_ENV.SERVER]: i18n.t('runMetadata.meta.env.cloud.label'),
};
